export default __webpack_public_path__ + "static/media/arrow-up.78872098.svg";